import { createBlueprint as e } from "@made-people/blueprint";
const t = e({
  slots: {
    base: "grid grid-cols-2",
    title: "text-label-md",
    linksWrapper: "flex flex-col gap-6 col-span-2 lg:col-span-1 items-start justify-start md:px-component-spacing-lg xl:px-component-spacing-2xl",
    link: "text-heading-md overflow-hidden before:content-none hover:before:content-['']",
    imageWrapper: "absolute top-0 left-0 w-full h-full origin-center aspect-square",
    images: "col-span-1 hidden lg:flex relative aspect-square bg-neutral-100",
    image: "absolute top-0 left-0 w-full h-full object-cover"
  },
  variants: {
    hasUnderlineAnimation: {
      true: {
        link: "transition-all"
      }
    },
    imageLayout: {
      basic: {
        images: "overflow-hidden max-h-[calc(100svh-32px)] min-w-full"
      },
      "stacked-cards": {
        images: "max-w-component-max-w-sm",
        image: "rounded-lg shadow-lg"
      }
    }
  },
  defaultVariants: {
    hasUnderlineAnimation: "true",
    imageLayout: "basic"
  }
});
export {
  t as linksHoverImageBlueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
